import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsParkingRule} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsParkingPassesService} from '../../../services/settings-parking-passes.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'settings-parking-rules-modal',
    templateUrl: './settings-parking-rules-modal.component.html',
    styleUrls: ['./settings-parking-rules-modal.component.scss']
})
export class SettingsParkingRulesModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: SettingsParkingRule = new SettingsParkingRule();
    disabledSubmit = false;
    multiselectSettings = {
        singleSelection: false,
        text: 'Select',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true
    };

    constructor(public api: ApiClientService,
                public settingsParkingPassesService: SettingsParkingPassesService,
                public authService: AuthenticationService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsParkingPassesService.showCreateModal = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParkingPassesService.showCreateModal = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name should not be blank.');
            if (!form.value.type) toastr.warning('Type should not be blank.');
            if (!form.value.lots || form.value.lots.length == 0) toastr.warning('Lots should not be blank.');
            return;
        }
        const name = form.value.name;
        const lots = form.value.lots;

        if (!name) {
            toastr.warning('Name is not set.');
            return;
        }
        if (!lots || lots.length == 0) {
            toastr.warning('Lots are not set.');
            return;
        }

        const data: any = {
            name: form.value.name,
            internalId: form.value.internalId,
            type: form.value.type,
            allowResidentsToBook: form.value.allowResidentsToBook,
            lotRule: this.parkingLotsFormatConvertion(this.data.parkingLots),
            enableStatus: 0
        };

        this.disabledSubmit = true;

        this.api.post('domainParkingPass', '/v1/parking_rule.json', data).subscribe(
            () => this.updateView('Parking Rule successfully created'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Create Parking Rule failed');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsParkingPassesService.getData();
        this.form.reset();
        this.hideModal();
    }

    parkingLotsFormatConvertion(lots): any {
        return lots.map((lot) => ({parkingLot: lot.id}));
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-rules-modal/settings-parking-rules-modal.component.ts